import moment from 'moment-timezone';
const CLIENT_LOCALE = "America/Sao_Paulo";

class Environment {
    static startOfCurrentDay() {
        return moment.tz(moment(), CLIENT_LOCALE).startOf("day");
    }

    static momentToLocalDateString(m) {
        return moment(m).tz(CLIENT_LOCALE).format('DD/MM/YYYY');
    }

    static momentToLocalTimeString(m) {
        return moment(m).tz(CLIENT_LOCALE).format('HH:mm');
    }

    static momentToLocalDateAndTimeString(m) {
        return moment(m).tz(CLIENT_LOCALE).format("DD/MM/YYYY HH:mm")
    }

    static momentToLocalDateAndTimeWithoutYearString(m) {
        return moment(m).tz(CLIENT_LOCALE).format("DD/MM HH:mm")
    }

    static localDateAndTimeStringToMoment(str) {
        return moment.tz(str, "DD/MM/YYYY HH:mm:ss", CLIENT_LOCALE);
    }

    static localDateAndTimeStringToIso(str) {
        return this.localDateAndTimeStringToMoment(str).toISOString();
    }

    static formataQuantidadeSegundos (tempo_segundos) {
        const duasCasas = (numero) => {
            let num;
            num = numero <= 9 ? '0' + numero : numero;
            return num;
        }

        const dias = Math.trunc(tempo_segundos / (3600 * 24));
        const horas = duasCasas(Math.trunc(tempo_segundos % (3600 * 24) / 3600));
        const minutos = duasCasas(Math.trunc((tempo_segundos % 3600) / 60));
        const segundos = duasCasas((tempo_segundos % 3600) % 60);

        return dias + "d " + horas + "h " + minutos + "m " + segundos + "s";
    }

}

export default Environment;